<template>
  <component :is="tag" v-if="tag">
    <slot />
  </component>
  <slot v-else />
</template>

<script lang="ts" setup>
import { uniqueId } from 'lodash-es'

const props = defineProps<{
  oneAlwaysActive?: boolean
  tag?: keyof HTMLElementTagNameMap
}>()

const activeItem = ref<null | string>(null)
const groupId = uniqueId('collapse-group_')

provide('one-always-active', props.oneAlwaysActive)
provide('group-id', groupId)
provide('active-item', activeItem)
</script>
